import * as React from 'react'

const Success = (props: any) => (
  <svg {...props} viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <circle cx='24' cy='24' r='24' fill='#37C47E' fillOpacity='0.3' />
    <path
      d='M16.8312 33.6623C26.1268 33.6623 33.6623 26.1268 33.6623 16.8312C33.6623 7.53557 26.1268 0 16.8312 0C7.53557 0 0 7.53557 0 16.8312C0 26.1268 7.53557 33.6623 16.8312 33.6623Z'
      transform='translate(7.408 7.48)'
      fill='#37C47E'
      stroke='#37C47E'
      strokeWidth='7'
      strokeLinecap='round'
    />
    <path
      d='M18.9027 0L6.44626 12.029L0 5.01183'
      transform='translate(14.912 19.884)'
      stroke='#fff'
      strokeWidth='2.5'
    />
  </svg>
)

export default Success



// WEBPACK FOOTER //
// ./src/components/icons/membership/Success.tsx